<template>
    <section class="promo-banner-section" loading="lazy" v-if="sitePosters && sitePosters?.length">
        <div id="myDIV" class="banner-slider-img">
            <Carousel :wrapAround="true" :autoplay="3000" :items-to-show="1" class="owl-carousel owl-theme">  
                <Slide  v-for="(poster,index) in sitePosters" :key="index">
                    <div class="item">
                        <div class="carousel-inner-img">
                            <img loading="lazy" :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path.poster_path + poster?.image" :alt="poster.image">
                        </div>
                    </div>
                </Slide>
                <template #addons>
                    <Pagination />
                </template>
            </Carousel>
        </div>
    </section>
    <!-- <DepositModal /> -->
</template>

<script>

import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';

export default {
    name: "Banner",
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
  computed:{
    sitePosters() {
            if(this.$siteSettings?.data && this.$siteSettings?.data?.poster && this.$siteSettings?.data?.poster.length) {
                return this.$siteSettings?.data?.poster?.filter(s => s.poster_type == 1)
            } 
            else {
                return [];
            }
        }
  }

};


</script>